import { OAuthTokenRequest } from '../models/auth';
import { Component } from '@opten/compiler/metadata/component';
import { HttpStatusCodes } from '../httpclient/status-codes';
import { authService, accountService } from '../shop/shop-context';
import { AccountBase, AccountBaseOptions } from './account-base';
import { HttpErrorResponse } from '../httpclient/httpclient';
import dispatchCustomEvent from '@opten/events/dispatch-custom-event';
import { mergeMap, toArray } from 'rxjs/operators';
import removeClass from '@opten/dom/remove-class';
import addClass from '@opten/dom/add-class';

@Component({ className: 'js-shop-sign-in' })
export class SignInComponent extends AccountBase {
	options: AccountBaseOptions = {
		selectors: {
			submitButton: 'js-shop-sign-in__submit'
		},
		disabled: '--disabled'
	};

	private _username: HTMLInputElement;
	private _password: HTMLInputElement;
	private _privacyPolicy: HTMLInputElement;
	private _redirectUrl = '';

	protected renderModel: {
		isGuest: boolean;
		showPrivacyPolicy?: boolean;
		submitError?: boolean;
		errorStatus?: string;
	};

	onInit(): void {
		super.onInit();
		this._username = this.formElement.elements.namedItem('username') as HTMLInputElement;
		this._password = this.formElement.elements.namedItem('password') as HTMLInputElement;
		this.fieldsToValidate.push(this._username, this._password);
		this.initSubmitOnEnter();
		this.initRedirectAfterLogin();
	}

	private initRedirectAfterLogin() {
		if (this.formElement && this.formElement.hasAttribute('data-redirect-url')) {
			this._redirectUrl = this.formElement.getAttribute('data-redirect-url');
		}
	}

	private initSubmitOnEnter() {
		if (this._password) {
			this._password.addEventListener('keypress', e => {
				// Number 13 is the "Enter" key on the keyboard
				// tslint:disable-next-line
				if (e.keyCode === 13) {
					// Cancel the default action, if needed
					e.preventDefault();
					this.handleSubmit();
				}
			});
		}
	}

	protected handleSubmit() {
		addClass(this.submitButton, 'is-loading');
		const request: OAuthTokenRequest = {
			grant_type: 'password',
			username: this._username.value,
			password: this._password.value
		};

		if (this._privacyPolicy && this._privacyPolicy.checked) {
			request.approvedPrivacyPolicy = this._privacyPolicy.checked;
		}

		authService.authenticate(request).subscribe(
			member => {
				this.shopContext.moveBasketFromGuestToUser(member);

				const isCustomerArea = document.getElementById('login-modal').getAttribute('data-customer-area');
				if (isCustomerArea === 'True') {
					window.location.reload();
				} else if (this._redirectUrl.length > 0) {
					window.location.href = this._redirectUrl;
				} else {
					dispatchCustomEvent(document.querySelector('#login-modal'), 'close');
					dispatchCustomEvent(document.querySelector('#basket-sign-up-modal'), 'close');
					this.shopContext.onAuthenticationChanged.next(member);
					this.renderModel.submitError = false;
				}
				removeClass(this.submitButton, 'is-loading');

				// clear basket when logging in
			},
			(error: HttpErrorResponse) => {
				this.renderModel.submitError = true;
				switch (error.status) {
					case HttpStatusCodes.unauthorized:
						this.renderModel.errorStatus = HttpStatusCodes[HttpStatusCodes.unauthorized];
						break;
					case HttpStatusCodes.notFound:
						this.renderModel.errorStatus = HttpStatusCodes[HttpStatusCodes.notFound];
						break;
					case HttpStatusCodes.notAcceptable:
						this.renderModel.errorStatus = HttpStatusCodes[HttpStatusCodes.notAcceptable];
						break;
					case HttpStatusCodes.forbidden:
						this.renderModel.errorStatus = HttpStatusCodes[HttpStatusCodes.forbidden];
						break;
					case HttpStatusCodes.preconditionFailed:
						this.renderModel.errorStatus = HttpStatusCodes[HttpStatusCodes.preconditionFailed];
						this._showPrivacyPolicy();
						break;
					default:
						this.renderModel.errorStatus = 'default';
				}
				this.renderer.render(this.formElement, this.renderModel, this);
				removeClass(this.submitButton, 'is-loading');
				removeClass(this.submitButton, '--disabled');
			}
		);
	}
	private _showPrivacyPolicy(): void {
		this.renderModel.showPrivacyPolicy = true;
		this._privacyPolicy = this.formElement.elements.namedItem('termsAndConditions') as HTMLInputElement;
		this.fieldsToValidate.push(this._privacyPolicy);
	}
}
